import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import copyIcon from "../../../assets/images/link_copy.svg";
import { OK } from "../../../constants/statusCode";
import { sendShareDocumentSettings } from "../../../features/chatbot/sendShareDocumentSettings";
import { shareAccessToggle } from "../../../features/chatbot/shareAccessToggleSlice";

const ShareDocumentModal = ({
  isOpen,
  toggle,
  project_slug_name,
  documentLink,
  setDocumentLink,
  source,
  typeOfAnswer,
  lengthValue,
  responseTone,
}) => {
  const [toggleChecked, setToggleChecked] = useState(documentLink);

  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const data = process.env.REACT_APP_IFRAME_BASEURL;

  useEffect(() => {
    setTimeout(() => {
      setShow("");
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const saveShareDocumentSettings = async (_toggleKey) => {
    const { payload } = await dispatch(
      shareAccessToggle({
        _toggleKey: _toggleKey === false ? 1 : 0,
        project_slug_name: project_slug_name,
      })
    );
   /*  if (payload.status === OK) {
      toggle();
    } */
  };

  return (
    <>
      <Modal
        className="add-document-popup share_chatbot share_chatbot_modal"
        show={isOpen}
        onHide={toggle}
        centered={true}
        // modalTransition={{ timeout: 2000 }}
        dialogClassName="common-modal"
      >
        <Modal.Header className="border-0">
          <h3 className="modal-title" id="Add_OrganizationLabel">
            Share
          </h3>
          {/* <button type='button' className='btn d-flex dlet-btn me-2'><img src="/static/media/trash.72657b09efa409e79727b60dd2c7bc45.svg" alt="" />
                </button> */}

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              toggle();
              setDocumentLink(!documentLink);
            }}
          ></button>
        </Modal.Header>
        <Modal.Body>
          <div className="row custom-switch-row mt-0">
            <div className="row col-md-12">
              <div className="col-md-6 form-group align-items-center mb-0">
                <div className="custom-switch-main ms-0 me-3 h-100">
                  <input
                    type="checkbox"
                    id="share-switch"
                    defaultChecked={documentLink}
                    onChange={(e) => {
                      saveShareDocumentSettings(documentLink);
                      setDocumentLink(e.target.checked);
                    }}
                  />
                  <label className="form-label " htmlFor="share-switch">
                    Enable Share Page
                  </label>
                </div>
                <label
                  className={
                    !documentLink
                      ? `form-label switch-label disable-form-label h-100`
                      : `form-label switch-label h-100`
                  }
                >
                  Enable Share Page
                </label>
              </div>
              <div className="col-md-6 d-flex justify-content-end p-0">
                {documentLink && (
                  <button
                    type="button"
                    className="btn advance-btn p-0 d-flex"
                    onClick={() =>
                      navigate("/settings", {
                        state: {
                          status: "share",
                        },
                      })
                    }
                  >
                    Advance Option
                  </button>
                )}
              </div>
            </div>
          </div>
          <label className="form-label mt-2">
            You can copy and share this link with your team or client
          </label>
          <div className="d-flex justify-content-between">
            <div className="form-group w-100">
              <input
                type="text"
                placeholder="Enter new label"
                name="label"
                value={`${
                  !documentLink
                    ? "Sharing is disabled"
                    : `${process.env.REACT_APP_IFRAME_BASEURL}/${project_slug_name}`
                }`}
                disabled={!documentLink}
                className="form-control sharing-control"
              />
            </div>
            <div>
              {documentLink && (
                <>
                  {/* {show && <div className="chat-tooltip-inner">copied!!</div>} */}
                  <CopyToClipboard
                    text={`${data}/${project_slug_name}`}
                    onCopy={() => {
                      setShow(true);
                    }}
                  >
                    <button className="btn copy-btn">
                      {" "}
                      <img src={copyIcon} alt="copy" />
                      <div
                        className={
                          !show
                            ? `chat-tooltip-inner d-none`
                            : `chat-tooltip-inner `
                        }
                      >
                        copied!!
                      </div>
                    </button>
                  </CopyToClipboard>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        {/*   <Modal.Footer>
          <div className="justify-content-end d-flex w-100">
            <button
              type="submit"
              className="btn btn-primary-md"
              onClick={() => {
                setDisableOnsubmit(true);
                saveShareDocumentSettings(documentLink);
              }}
              disabled={disableOnsubmit}
            >
              Save
            </button>
          </div>
        </Modal.Footer> */}
        {/* <Modal.Footer>
                    <Button type="button" disabled={isLoading} className="btn btn-primary-md" onClick={() => createNewDoc()}>Save</Button>
                </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default ShareDocumentModal;
